import * as React from "react"
import { Link } from "gatsby"

const ContactUsSection = (props) => {

    let title = 'Find the right solution for your Walmart items'
    if(props.title !== undefined) {
        title = props.title
    }

    let body = 'Fill out our contact form to identify which SKU Ninja solution will best help your business grow!'
    if(props.body !== undefined) {
        body = props.body
    }

    return (
        <div data-sal="slide-up" data-sal-delay="400" data-sal-duration='800' data-sal-easing="ease" className='container'>
            <h1 className='mb-4 text-center text-dark text-uppercase'>{title}</h1>
            {props.body === false ?
                <></>
            :
                <div className='row'>
                    <p className='mb-4 mx-auto text-center text-header font-lg col-xl-6 col-lg-8'>{body}</p>
                </div>
            }
            <div className='justify-content-center d-flex'>
                <Link to="https://www.flywheeldigital.com/contact-us">
                    <button className='btn btn-yellow'>
                        Contact Us
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default ContactUsSection;